import gql from 'graphql-tag';

// Every document that selects a VdoSetTopic here also selects playbackUrl
// and playbackStatus. resolveVideoSource (src/utils/video-source.js) depends
// on that habit: an undefined playbackStatus in the frontend means a query
// forgot to ask for it, and throws rather than silently rendering an empty
// player. scripts/check-video-fields.js is the build-time gate for this same
// contract on the query documents themselves.
const TOPIC_FIELDS = `
  id
  no
  nameLocal
  nameEng
  vdoLength
  vdoStreamPath
  playbackUrl
  playbackStatus
  videoProvider
  bunnyVideoGuid
  bunnyStatus
  bunnyStatusAt
`;

export const CREATE_BUNNY_UPLOAD = gql`
  mutation createBunnyUpload($vdoSetTopicId: ID!, $title: String!) {
    createBunnyUpload(vdoSetTopicId: $vdoSetTopicId, title: $title) {
      videoGuid
      libraryId
      authorizationSignature
      authorizationExpire
      tusEndpoint
      collectionId
    }
  }
`;

export const REFRESH_BUNNY_STATUS = gql`
  mutation refreshBunnyStatus($vdoSetTopicId: ID!) {
    refreshBunnyStatus(vdoSetTopicId: $vdoSetTopicId) { ${TOPIC_FIELDS} }
  }
`;

export const DELETE_BUNNY_VIDEO = gql`
  mutation deleteBunnyVideo($vdoSetTopicId: ID!) {
    deleteBunnyVideo(vdoSetTopicId: $vdoSetTopicId) {
      ${TOPIC_FIELDS}
      vdoSet { id totalVdoLength }
      vdoSetUnit { id totalVdoLength }
    }
  }
`;

export const CANCEL_BUNNY_UPLOAD = gql`
  mutation cancelBunnyUpload($vdoSetTopicId: ID!) {
    cancelBunnyUpload(vdoSetTopicId: $vdoSetTopicId) { ${TOPIC_FIELDS} }
  }
`;

export const BUNNY_DOWNLOAD_URL = gql`
  query bunnyDownloadUrl($vdoSetTopicId: ID!) {
    bunnyDownloadUrl(vdoSetTopicId: $vdoSetTopicId)
  }
`;
